module.exports = __webpack_public_path__ + "static/media/sparks.9541e3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Airplane/images/sparks.jpg
// module id = 224
// module chunks = 2